import { Generic404 } from "../pagelayouts/generic-error-page";

const About = () => {
    return <Generic404 />
}

export default About;